module.exports = __webpack_public_path__ + "img/陆丰海岸.b326c5ab.jpg";